import { render } from "./WhatPage.vue?vue&type=template&id=1dfe59cc&scoped=true"
import script from "./WhatPage.vue?vue&type=script&lang=js"
export * from "./WhatPage.vue?vue&type=script&lang=js"

import "./WhatPage.vue?vue&type=style&index=0&id=1dfe59cc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dfe59cc"]])

export default __exports__